/**
 * History of an Eingang and one reply sent from it. live → /posteingang/:commId/activity
 * and /sent/:sentId; mock → demo data. The history loads only while the panel is open.
 */

import { useQuery } from '@tanstack/react-query';
import type { PosteingangActivityEntry, PosteingangSentMail } from '@brokly/shared';
import { apiClient } from '../../../lib/api-client';
import { isLiveData } from '../../../lib/data-mode';
import { qk } from '../../../lib/query-keys';
import { posteingangActivityMock, posteingangSentMailMock } from '../mock';

export function useEingangActivity(commId: string | null, enabled = true) {
  const live = isLiveData();
  return useQuery<PosteingangActivityEntry[]>({
    queryKey: qk.posteingangActivity(commId ?? 'none', live ? 'live' : 'mock'),
    queryFn: async () =>
      live
        ? (await apiClient.posteingang.activity(commId as string)).data
        : posteingangActivityMock(commId as string),
    enabled: enabled && commId !== null,
  });
}

export function useEingangSentMail(commId: string | null, sentId: string | null) {
  const live = isLiveData();
  return useQuery<PosteingangSentMail | null>({
    queryKey: qk.posteingangSentMail(commId ?? 'none', sentId ?? 'none', live ? 'live' : 'mock'),
    queryFn: () =>
      live
        ? apiClient.posteingang.sentMail(commId as string, sentId as string)
        : Promise.resolve(posteingangSentMailMock(commId as string, sentId as string)),
    enabled: commId !== null && sentId !== null,
  });
}
